import {
  WER_REFEENCE_PDFS,
  ACCESS_TOKEN,
  CASE_SUBTYPE,
  CASE_TYPE_NTB,
  PRODUCT_NAME,
  CASE_ID,
  CASE_TYPE_EXISTING,
  LINK_CODE_KEY,
  ROUTE_PERSONAL_INFO_PAGE
} from '../../utils/constants';
export const bankId = state => state.config.get('bank_id');
export const brandId = state => state.config.get('brand_id');
export const accessToken = state => state.config.get('access_token');
export const apiBaseUrlLiberty = state => state.config.get('apiBaseUrlLiberty');
export const stubsEnabled = state => state.config.get('stubs');
export const apiBaseUrl3 = state => state.config.get('apiBaseUrl3');
export const apiBaseUrlPaas = state => state.config.get('apiBaseUrlPaas');
export const resumeType = state => state.config.get('type');

const CORP_ADMIN_URL_SUFFIX = 'fair-processing?user_type=BAU';

export const getProductName = state => {
  const product = state.config.get(PRODUCT_NAME);
  return product ? decodeURIComponent(product) : '';
};

export const isExisting = state => {
  const subType = state.config.get(CASE_SUBTYPE);
  const caseId = state.config.get(CASE_ID);
  if (subType && !caseId) {
    return subType !== CASE_TYPE_NTB;
  }
  return caseId ? true : state.config.get(ACCESS_TOKEN) ? true : false;
};

export const caseType = state => {
  const subType = state.config.get(CASE_SUBTYPE);
  const caseId = state.config.get(CASE_ID);
  if (subType && !caseId) {
    return subType !== CASE_TYPE_NTB;
  }
  return subType ? subType : state.config.get(ACCESS_TOKEN) ? CASE_TYPE_EXISTING : CASE_TYPE_NTB;
};

export const getSingleEntry = (state, key) => state.config.get(key);

export const getAllDocuments = state =>
  state && state.config ? state.config.get(WER_REFEENCE_PDFS) : [];

export const getPdfByWebReference = (state, webReferences) => {
  const businessAccountsUrl = state.config.get('businessAccountsUrl');
  return `${businessAccountsUrl}/documents/${webReferences}`;
};

export const getIDVurl = state => {
  const brandid = brandId(state);
  const bankid = bankId(state);
  const urls = state.config;
  if (urls) {
    const idv = urls.toJS().authenticationUrl;
    const baa = encodeURIComponent(
      `${urls.toJS().businessAccountsUrl}?linkCode=${state.config.get(
        LINK_CODE_KEY
      )}&page=${ROUTE_PERSONAL_INFO_PAGE}&pBankId=${bankid}`
    );
    return `${idv}/${brandid.toUpperCase()}?client_id=vmbaa_web&response_type=token&redirect_uri=${baa}`;
  }
  return '';
};

export const getCorpAdminUrl = state => {
  const brandid = brandId(state);

  const urls = state.config;
  if (urls) {
    const idv = urls.toJS().authenticationUrl;
    return `${idv}/${brandid.toLowerCase()}/${CORP_ADMIN_URL_SUFFIX}`;
  }
  return '';
};
